import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Switch Icon Style 01 - Switch (Material Symbol)
 * - isOn = true: 綠色實心開關 (FILL: 1)
 * - isOn = false: 灰色空心開關 (FILL: 0)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:switch
 */
export const Style01_Switch: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-green-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      switch
    </span>
  );
};

export default Style01_Switch;
